import { getConfig } from '@config/index'

import { type NavLinkItem } from '@components/ui-core/types'

const config = getConfig()

export const footerContent: NavLinkItem[] = [
  {
    label: 'Products',
    links: [
      {
        label: 'Superhuman Go',
        href: '/products/go-ai-assistant',
      },
      {
        label: 'Grammarly',
        href: '/products/grammarly',
      },
      {
        label: 'Coda',
        href: '/products/coda',
      },
      {
        label: 'Superhuman Mail',
        href: config.paths.mail.landing,
      },
      {
        label: 'Agent Store',
        href: config.paths.agentStore,
      },
    ],
  },
  {
    label: 'Company',
    links: [
      {
        label: 'Contact Us',
        href: '/contact',
      },
      {
        label: 'Help Center',
        href: '/support',
      },
      {
        label: 'Careers',
        href: 'https://job-boards.greenhouse.io/grammarly',
        openIn: 'newTab',
      },
    ],
  },
  {
    label: 'Legal',
    links: [
      {
        label: 'Terms',
        href: '/legal/terms',
      },
      {
        label: 'Privacy Policy',
        href: 'https://www.grammarly.com/privacy-policy',
        openIn: 'newTab',
      },
      {
        label: 'Trust',
        href: '/legal/trust',
      },
      {
        label: 'Customer Business Agreement',
        href: '/legal/terms/customer-business-agreement',
      },
    ],
  },
]
